import React, { useState } from "react";
import { Box } from "@mui/material";
import cn from "classnames";
import { observer } from "mobx-react";
import { useHistory } from "react-router-dom";

import { useLocale } from "src/providers/LocaleProvider";
import useStores from "src/hooks/useStores";
import { usePlayer } from "src/sounds/use-player";
import { IGame } from "src/store/models";
import cancelGame from "src/pages/lobby/assets/cancel.svg";
import newGameProfileIcon from "src/pages/lobby/components/LobbyTable/images/profile.svg";
import friendsIcon from "src/pages/lobby/assets/friendsIcon.svg";
import paths from "src/consts/paths";
import useChangeTheme from "src/hooks/useChangeTheme";

import { useStyles } from "../styles";

interface ICreateBlock {
    isWaitingForGameBlock?: boolean | IGame | undefined;
    isMobileNewGame?: boolean;
    handleCreateGame?: () => void;
    stopSearching?: () => void;
}

const StopGameMobile = ({ stopSearching }: ICreateBlock) => {
    const { authStore, lobbyStore } = useStores();
    //@ts-ignore
    const classes = useStyles();
    const history = useHistory();
    const {
        header: { profile },
        profile: {
            friends: { title },
        },
        lobby: {
            createGame: {
                buttons: { stop },
            },
        },
    } = useLocale();

    const appearanceTheme = useChangeTheme();

    const user = authStore.currentUser;
    if (!user) return null;

    return (
        <Box component="div" className={classes.gameOrFriendscontainer}>
            <Box
                component="div"
                className={cn(
                    classes.gameOrFriendsContainerBox,
                    appearanceTheme,
                    {}
                )}
            >
                <Box
                    component="div"
                    className={cn(classes.startLobbyUserButtons)}
                    onClick={() => {
                        history.push(paths.profile);
                    }}
                >
                    <div className={cn(classes.mobileGameBlocks)}>
                        <img
                            className={cn(
                                classes.mobileGameBlocks,
                                "icon",
                                "profile"
                            )}
                            src={newGameProfileIcon}
                        />
                        <p className={cn(classes.mobileGameBlocks, "text")}>
                            {profile("Profile")}
                        </p>
                    </div>
                </Box>
                <Box
                    component="div"
                    className={cn(classes.buttonWrapper)}
                    onClick={() => {
                        stopSearching && stopSearching();
                    }}
                >
                    <img
                        className={cn(classes.openCreateIcon)}
                        src={cancelGame}
                        alt="cancel"
                        loading="lazy"
                    />
                </Box>
                <Box
                    component="div"
                    className={cn(classes.startLobbyUserButtons)}
                >
                    <div
                        className={cn(classes.mobileGameBlocks)}
                        onClick={() => {
                            lobbyStore.openmobileFriends(true);
                        }}
                    >
                        <img
                            className={cn(classes.mobileGameBlocks, "icon")}
                            src={friendsIcon}
                        />
                        <p className={cn(classes.mobileGameBlocks, "text")}>
                            {title("Friends")}
                        </p>
                    </div>
                </Box>
            </Box>
        </Box>
    );
};

export default observer(StopGameMobile);
